(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('SharedData', function () {
            return {
                Cart: null,
                CartUpdateDate: ''
            }
        });
})();